import { apiClient } from "@/services/api-client";

export const getNotificationsApi = () => {
  return apiClient.get("/v1/notifications");
};
